import {
  List, Datagrid, TextField, EditButton, Edit, Create, SimpleForm,
  TextInput, NumberInput, required,
} from 'react-admin';
import { Stack } from '@mui/material';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import { ImageUploadInput } from '../../components/ImageUploadInput.jsx';
import { TiptapInput } from '../../components/TiptapInput.jsx';

const MessageList = () => (
  <List sort={{ field: 'sortOrder', order: 'ASC' }} perPage={25}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="label" />
      <TextField source="name" />
      <TextField source="role" />
      <EditButton />
    </Datagrid>
  </List>
);

const MessageForm = () => (
  <Stack spacing={2} sx={{ maxWidth: 800 }}>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextInput source="label" label='Label (e.g. "Principal", "Founding Principal")' validate={required()} fullWidth />
      <NumberInput source="sortOrder" defaultValue={0} />
    </Stack>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextInput source="name" validate={required()} fullWidth />
      <TextInput source="role" fullWidth />
    </Stack>
    <ImageUploadInput source="photo" label="Photo" />
    <TextInput source="excerpt" multiline minRows={2} fullWidth helperText="Short blurb shown on the homepage." />
    <TiptapInput source="fullMessage" label="Full message" />
    <TextInput source="link" label="Link (e.g. /principals-message)" fullWidth />
  </Stack>
);

const MessageEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm><MessageForm /></SimpleForm>
  </Edit>
);
const MessageCreate = () => (
  <Create redirect="list">
    <SimpleForm><MessageForm /></SimpleForm>
  </Create>
);

export default {
  list: MessageList,
  edit: MessageEdit,
  create: MessageCreate,
  icon: RecordVoiceOverIcon,
  options: { label: 'Leadership messages' },
  recordRepresentation: 'name',
};
